export function log_instance(target) {
    window['selected_instance'] = target;
    console.info('[DEBUG]: selected instance can be accessed by `window.selected_instance`', target);
}
//# sourceMappingURL=LogInstance.js.map